import React, { Component } from 'react';
import { connect } from 'react-redux';
import FormatText from '../../../helpers/FormatTitle';
import { navigation_geo_select_geo, navigation_geo_toggle_close, navigation_load_menu } from './../../../redux/reducers/navigationSlice';

function mapStateToProps(state, ownProps) {
   return {
      SelectedGeography: state.navigation.selectedGeography
   };
}

const mapDispatchToProps = (dispatch, ownProps) => {
   return {
      selectGeography: geography => {
         dispatch(navigation_geo_select_geo(geography));
      },
      navGeoToggleClose: () => {
         dispatch(navigation_geo_toggle_close());
      },
      loadMenu: id => {
         dispatch(navigation_load_menu(id));
      }
   };
};

class NavGeography extends Component<
   {
      id: string;
      name: string;
      selectGeography: any;
      SelectedGeography: string;
      navGeoToggleClose: any;
      loadMenu: any;
   },
   {}
> {
   constructor(props) {
      super(props);
      this.onClick = this.onClick.bind(this);
   }

   private onClick() {
      this.props.selectGeography(this.props.name);
      this.props.navGeoToggleClose();
      this.props.loadMenu(this.props.id);
   }

   public render() {
      const { name, SelectedGeography } = this.props;

      const geographyStyles = () => {
         const isActive = SelectedGeography === name ? 'active' : '';
         return `${isActive}`;
      };

      return (
         <a className={geographyStyles()} data-analytics={`Forecasts-Navigation-Geography-${FormatText(name)}`} onClick={this.onClick}>
            {name}
         </a>
      );
   }
}

export default connect(mapStateToProps, mapDispatchToProps)(NavGeography);
